module.exports = __webpack_public_path__ + "media/images/front/home_3-c95b10c1c633389b78a15f5d8a33773e.jpg";